import { render, staticRenderFns } from "./PharmaDaily.vue?vue&type=template&id=70655d5d&scoped=true"
import script from "./PharmaDaily.vue?vue&type=script&lang=js"
export * from "./PharmaDaily.vue?vue&type=script&lang=js"
import style0 from "./PharmaDaily.vue?vue&type=style&index=0&id=70655d5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70655d5d",
  null
  
)

export default component.exports